import {useState} from 'react';
import {Translate} from 'react-redux-i18n';
import {useHistory} from 'react-router-dom';

import {Stepper} from 'front-onceforall-core';

import ActionBar from '../../layout/ActionBar';

import {steps} from './utils';

function ProjectCreationFunnel() {
  const [project, setProject] = useState(null);
  const [interventionId, setInterventionId] = useState(null);
  const history = useHistory();

  const onNextStep = (_step, data) => {
    if (data) {
      setProject(data.project);
      setInterventionId(data.interventionId);
    }
  };

  const onFinish = () => {
    history.push(`/project/${project.projectId}/intervention/${interventionId}`);
  };

  return (
    <div className="w-100">
      <div className="mt-3 mb-4">
        <ActionBar showBackButton>
          <h1 className="m-0 ml-4"><Translate value="project.create.title"/></h1>
        </ActionBar>
      </div>
      <Stepper
        steps={steps}
        onNextStep={onNextStep}
        onFinish={onFinish}
        stepProps={{project, interventionId}}
      />
    </div>
  );
}

export default ProjectCreationFunnel;
